export interface ReviewItem {
  id: string;
  name: string;
  role: string;
  avatarHue: string;
  content: string;
  tags: string[];
}

export const reviews: ReviewItem[] = [
  {
    id: "rev-1",
    name: "阿澈",
    role: "追更三年的老读者",
    avatarHue: "bg-primary-500",
    content:
      "上次网页打不开急得不行，按帮助里的步骤清了缓存换了个网络就好了，全程没求人。现在遇到问题都是先来这儿翻一翻，省心。",
    tags: ["打不开", "亲测有效"],
  },
  {
    id: "rev-2",
    name: "柠檬酱",
    role: "通勤党",
    avatarHue: "bg-accent-500",
    content:
      "地铁上信号差加载慢，按照流畅模式的建议切了画质，翻页顺多了。收藏同步这个技巧也救了我，换手机不慌。",
    tags: ["加载慢", "画质切换"],
  },
  {
    id: "rev-3",
    name: "老张",
    role: "夜猫子读者",
    avatarHue: "bg-secondary-500",
    content:
      "换源失败的说明写得很清楚，按顺序一个个源试过来，总能找到能看的。收藏恢复那几条也靠谱，点赞。",
    tags: ["换源", "收藏恢复"],
  },
  {
    id: "rev-4",
    name: "Momo",
    role: "漫画爱好者",
    avatarHue: "bg-primary-700",
    content:
      "搜索无结果的时候最容易急，按提示精简关键词一下就找到了。这个帮助中心真的很接地气，步骤简单看得懂。",
    tags: ["搜索", "简单易懂"],
  },
];